import { render, staticRenderFns } from "./RenderImage.vue?vue&type=template&id=da1768f6&"
import script from "./RenderImage.vue?vue&type=script&lang=ts&"
export * from "./RenderImage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Buildserver\\Agent01\\_work\\1030\\s\\JCD.Retail.Webshop\\App\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('da1768f6')) {
      api.createRecord('da1768f6', component.options)
    } else {
      api.reload('da1768f6', component.options)
    }
    module.hot.accept("./RenderImage.vue?vue&type=template&id=da1768f6&", function () {
      api.rerender('da1768f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/webshop/components/utilities/RenderImage.vue"
export default component.exports